import React from 'react';
import { Grid, InputAdornment, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { RegularRate, doubleTimeFactor, doubleTimeRate } from 'app/models/Placement/PlacementMods';
import { getCalculatedAmount } from './OvertimeFactor';
import { isNumber } from '../../../ModificationsUtils';
import { validDecimal } from 'app/helpers/numberHelper';
import { getInvalidAmount } from '../../BillRate/HourlyRates/BillOrientation';

export const DoubleTimeFactor = ({
  classes,
  currentMod,
  isModEdit,
}: {
  classes: any;
  currentMod?: string;
  isModEdit?: boolean;
}) => {
  const { t } = useTranslation();
  const { control, getValues, setValue } = useFormContext();
  const doubleTimeFactorValue = useWatch<any>({ name: doubleTimeFactor });
  const regularRateValue = useWatch({ name: RegularRate });

  return (
    <Grid className={currentMod ? null : classes.rateMargin}>
      <Controller
        name={doubleTimeFactor}
        control={control}
        render={({ field: { onChange, value, ...rest } }) => (
          <TextField
            value={doubleTimeFactorValue}
            variant="filled"
            label={`${t(`placement.placementMods.${doubleTimeFactor}`)}`}
            helperText={regularRateValue ? getCalculatedAmount(getValues, doubleTimeFactor) : getInvalidAmount()}
            className={currentMod ? classes.billFactorTextfields : classes.factorTextfields}
            InputLabelProps={{
              shrink: getValues(doubleTimeFactor),
            }}
            onChange={e => {
              if (validDecimal(e.target.value, { numberLength: 3, decimalLength: 2 })) {
                setValue(doubleTimeFactor, e.target.value);
                onChange(e.target.value);
                setValue(doubleTimeRate, '');
              }
            }}
            InputProps={{
              readOnly: !isModEdit,
              style: {
                pointerEvents: isModEdit ? 'auto' : 'none',
              },
              startAdornment: (
                <>
                  {isNumber(doubleTimeFactorValue) && (
                    <InputAdornment position="start">
                      <CloseIcon className={classes.iconClass} />
                    </InputAdornment>
                  )}
                </>
              ),
            }}
            {...rest}
          />
        )}
      />
    </Grid>
  );
};
